import * as React from 'react';
import ChallengeInfo from './ChallengeInfo';
import GoalAndStreak from './GoalAndStreak';
import TeamList from './TeamList';
import Help from './Help';
import { SideBarContainer } from './elements';

export default function SideBar(): React.ReactElement {
  return (
    <SideBarContainer>
      <ChallengeInfo />
      <GoalAndStreak />
      <TeamList />
      <Help />
    </SideBarContainer>
  );
}
